import { Box } from "@mui/material";
import { Page } from "../../models/programPageDefinition";

export interface PreviewProgramPanelProps {
    programPages: Page[];
    onClickPage: (idx: number) => void;
}

export function PreviewProgramPanel(props: PreviewProgramPanelProps) {

    function pageContent() {
        
    return (
        <Box display="flex" flexWrap="wrap" gap={2}>
            {props.programPages.map((page, idx) => (
                <Box
                    key={idx}
                    onClick={() => props.onClickPage(idx)}
                    sx={{
                        width: 120,
                        height: 160,
                        background: "#fff",
                        border: "2px solid #1976d2",
                        borderRadius: 2,
                        boxShadow: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#1976d2",
                        textAlign: "center",
                        p: 1,
                    }}
                >
                    <span>{page.title}</span>
                    {<img src=''/> }
                </Box>
            ))}
        </Box>
    );
}


    return (
        <div>
            <h2>Preview Custom Program</h2>
            {pageContent()}
        </div>
    );
}